module.exports = __webpack_public_path__ + "static/media/liberty-arm.bdd698c9.svg";